// import React, { useState, useRef, useEffect } from "react";
// import videojs from "video.js";
// import "video.js/dist/video-js.css";

// export default function VideoPlay({ videoOptions }) {
//   const videoRef = useRef(null);
//   const playerRef = useRef(null);
//   const [option, setOption] = useState({});

//   const init = () => {
//     if (!videoRef.current) return;

//     let _option = {
//       controls: true,
//       autoplay: videoOptions.autoplay || false, // 加载完成是否自动播放
//       loop: videoOptions.loop || false, // 视频播放结束后，是否循环播放
//       notSupportedMessage: "此视频暂无法播放，请稍后再试",
//       poster: videoOptions.poster || "", // 视频封面
//       controlBar: {
//         children: [
//           { name: "playToggle" }, // 播放按钮
//           {
//             name: "volumePanel", // 音量控制
//             inline: false, // 不使用水平方式
//           },
//           { name: "currentTimeDisplay" }, // 当前已播放时间
//           { name: "durationDisplay" }, // 总时间
//           { name: "progressControl" }, // 播放进度条
//           {
//             name: "pictureInPictureToggle", // 支持画中画
//           },
//           {
//             name: "FullscreenToggle", // 支持全屏
//           },
//         ],
//       },
//     };
//     setOption(_option);

//     if (!playerRef.current) {
//       const videoElement = videoRef.current;
//       if (!videoElement) return;

//       const player = (playerRef.current = videojs(
//         videoElement,
//         _option,
//         () => {}
//       ));
//     }
//   };

//   useEffect(() => {
//     init();
//     return () => {
//       if (playerRef.current) {
//         playerRef.current.dispose();
//         playerRef.current = null;
//       }
//     };
//   }, [
//     videoOptions.src,
//     videoOptions.type,
//     videoOptions.poster,
//     videoOptions.autoplay,
//     videoOptions.loop,
//   ]);

//   const handlePlay = () => {
//     if (playerRef.current) {
//       playerRef.current.play();
//     }
//   };
//   console.log(videoOptions);
//   return (
//     <div className="video_play">
//       <video
//         style={{
//           width: 600,
//           height: 300,
//         }}
//         ref={videoRef}
//         className="video-js vjs-big-play-centered"
//       >
//         <source
//           key={videoOptions.index}
//           src="http://vfx.mtime.cn/Video/2021/07/10/mp4/210710122716702150.mp4"
//           type={videoOptions.type || ""}
//         />
//       </video>
//       <button onClick={handlePlay}>播放</button>
//     </div>
//   );
// }

import React, { useState, useRef, useEffect } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default function VideoPlay(props) {
  const {} = props;
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [option, setOptopm] = useState({});

  const onReadyPlay = (palyer) => {
    videoRef.current = palyer;
    palyer.play();
  };

  const init = () => {
    let _option = {
      controls: true,
      autoplay: props.autoplay || false, //加载完成是否自动播放
      loop: false, //视频播放结束后，是否循环播放
      notSupportedMessage: "此视频暂无法播放，请稍后再试",
      poster:
        props.poster ||
        "https://t7.baidu.com/it/u=1819248061,230866778&fm=193&f=GIF", //视频封面
      controlBar: {
        timeDivider: true, //是否显示时间控制条，默认为true
        remainingTimeDisplay: false, //是否显示剩余时间，默认为true
        // fullscreenToggle: true // 全屏按钮
        children: [
          //自定义
          { name: "playToggle" }, // 播放按钮
          {
            name: "volumePanel", // 音量控制
            inline: false, // 不使用水平方式
          },
          { name: "currentTimeDisplay" }, // 当前已播放时间
          { name: "durationDisplay" }, // 总时间
          { name: "progressControl" }, // 播放进度条
          {
            name: "pictureInPictureToggle", //支持画中画
          },
          {
            name: "FullscreenToggle", //支持全屏
          },
        ],
      },
    };
    setOptopm(_option);

    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      const player = (playerRef.current = videojs(
        videoElement,
        _option,
        () => {}
      ));
      onReadyPlay(player);
    }
  };

  useEffect(() => {
    init();
  }, [props.src]);
  function getVideoType(url) {
    if (!url) {
      console.error("URL is undefined or null");
      return "application/octet-stream"; // 默认类型
    }

    const extension = url.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "mp4":
        return "video/mp4";
      case "webm":
        return "video/webm";
      case "ogg":
        return "video/ogg";
      // 可以根据需要添加更多类型
      default:
        // return "application/octet-stream"; // 默认类型
        return "video/mp4";
    }
  }
  const videoType = getVideoType(props.src);
  return (
    <div
      className="video_play"
      style={{ width: props.width || "", height: props.height || "" }}
    >
      <video
        // className="detail_user_video"

        style={{ width: props.width || "", height: props.height || "" }}
        ref={videoRef}
        className={`video-js vjs-big-play-centered ${props.className}`}
      >
        {/* <source src={`http://vjs.zencdn.net/v/oceans.mp4`} type="video/mp4" />
        <source
          src={`https://live-s3m.mediav.com/nativevideo/2a80d171cc7ef2c764c9a83c06e0e4bc-bit_cloud768.mp4`}
          type="video/mp4"
        /> */}
        <source src={props.src} type={videoType} />
      </video>
    </div>
  );
}
